
function getInterfaceData(data){
    return data.data;
}

export default getInterfaceData;